import React from 'react';
import styled from 'styled-components';
import { Field } from 'react-final-form';

import { Chip as MuiChip, Checkbox as MuiCheckbox } from '@mui/material';

const FormChipRadioButton = ({
  name,
  value,
  label,
  onChange,
  defaultValue,
  rounded = true,
  isBig = false,
  width,
  height,
  disabled,
  ...props
}) => {
  return (
    <Field
      defaultValue={defaultValue}
      name={name}
      value={value}
      component="input"
      type="checkbox"
      label={label}
      id={value}
      disabled={disabled}
      {...props}
    >
      {({ input, meta }) => {
        return (
          <SLabel>
            <SMuiCheckbox {...input} {...props} disabled={disabled} />
            <SMuiChip
              disabled={disabled}
              width={width}
              height={height}
              isBig={isBig}
              label={label}
              color="primary"
              rounded={rounded}
              onClick={() => onChange(value)}
              variant={input.checked ? 'default' : 'outlined'}
            />
          </SLabel>
        )
      }}
    </Field>
  );
};

const SLabel = styled.label`
  display: block;
  box-sizing: border-box;
  & + label {
    margin-left: 5px;
  }
`
const SMuiCheckbox = styled(MuiCheckbox)`
  width: 0;
  height: 0;
  opacity: 0;
  padding: 0 !important;
  position: absolute !important;
  left: 0;
  top: 0;
`

const SMuiChip = styled(MuiChip)`
  width: ${({width}) => width ? `${width}px` : 'auto'} !important;
  height: ${({height}) => height ? `${height}px` : 'auto'} !important;
  box-sizing: border-box;
  font-weight: 600;
  font-size: ${({isBig}) => isBig ? '16px' : '14px'} !important;
  line-height: ${({isBig}) => isBig ? '22px' : '19px'} !important;
  width: ${({isBig, width}) => isBig ? '190px' : width ? `${width}px` : 'auto'} !important;
  height: ${({isBig, height}) => isBig ? '40px' : height ? `${height}px` : 'auto'} !important;
  color: ${({theme}) => theme.palette.colors.white} !important;
  background: ${({theme}) => theme.palette.colors.blue100} !important;
  border-radius: ${({rounded}) => rounded ? '20px' : '5px'} !important;
  &.MuiChip-outlined {
    color: ${({theme}) => theme.palette.colors.black100} !important;
    border-color: ${({theme}) => theme.palette.colors.blue200} !important;
    background: transparent !important;
  }
  span {
    padding: ${({width, height}) => width && height ? 0 : '8px 20px'} !important;
  }
`

export default FormChipRadioButton;